const contactTranslations = {
  en: {
    pageTitle: "Contact Us",
    heroTitle: "Get in Touch with Akaal Kids",
    heroDesc:
      "We would be happy to hear from you and guide you on your child’s Gurmat learning journey. Whether you have questions about enrollment, batches, or learning support — our team is here to help.",
    contactInfoTitle: "Contact Information",
    contactInfo: [
      {
        label: "Online Gurmat Education Institute",
        value: "Founded under Shan-E-Khalsa (Since 2006)",
        icon: "📍",
      },
      { label: "Website", value: "www.akaalkids.com", icon: "🌐" },
      { label: "Email", value: "akaalkids@gmail.com", icon: "📧" },
      { label: "WhatsApp / Phone", value: "+91 62837 90049", icon: "📱" },
    ],
    globalTitle: "Global Learning Community",
    globalDesc: "Akaal Kids proudly serves families across:",
    countries: [
      "India",
      "United States",
      "Canada",
      "United Kingdom",
      "Australia",
      "Other countries worldwide",
    ],
    globalNote:
      "Our online format allows children to learn Gurmat from anywhere in the world.",
    supportTitle: "When Can You Contact Us?",
    supportHours: "Support Hours",
    supportTime: "Monday to Saturday\n10:00 AM – 7:00 PM (IST)",
    supportNote:
      "Messages received outside support hours will be responded to at the earliest.",
    guidanceTitle: "Enrollment & Guidance Support",
    guidanceDesc: "You may contact us for:",
    guidancePoints: [
      "Enrollment assistance",
      "Batch and level guidance",
      "Class schedule information",
      "Technical or learning support",
      "General inquiries about Akaal Kids",
    ],
    guidanceNote: "Our team responds with care, clarity, and respect.",
    parentTitle: "A Message for Parents",
    parentDesc:
      "At Akaal Kids, we believe Gurmat education is a partnership between parents, teachers, and children. We welcome your questions and look forward to walking this spiritual journey together.",
  },
  pa: {
    pageTitle: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    heroTitle: "ਅਕਾਲ ਕਿਡਜ਼ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    heroDesc:
      "ਅਸੀਂ ਤੁਹਾਡੇ ਸਵਾਲਾਂ ਦਾ ਜਵਾਬ ਦੇਣ ਅਤੇ ਤੁਹਾਡੇ ਬੱਚੇ ਦੀ ਗੁਰਮਤਿ ਸਿੱਖਿਆ ਯਾਤਰਾ ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਹਮੇਸ਼ਾਂ ਤਿਆਰ ਹਾਂ।",
    contactInfoTitle: "ਸੰਪਰਕ ਜਾਣਕਾਰੀ",
    contactInfo: [
      {
        label: "ਆਨਲਾਈਨ ਗੁਰਮਤਿ ਸਿੱਖਿਆ ਸੰਸਥਾ",
        value: "ਸ਼ਾਨ-ਏ-ਖ਼ਾਲਸਾ ਦੇ ਅਧੀਨ (ਸਥਾਪਨਾ 2006)",
        icon: "📍",
      },
      { label: "ਵੈਬਸਾਈਟ", value: "www.akaalkids.com", icon: "🌐" },
      { label: "ਈਮੇਲ", value: "akaalkids@gmail.com", icon: "📧" },
      { label: "ਵਟਸਐਪ / ਫ਼ੋਨ ਨੰਬਰ", value: "+91 62837 90049", icon: "📱" },
    ],
    globalTitle: "ਵਿਸ਼ਵ ਪੱਧਰੀ ਸਿੱਖਿਆ",
    globalDesc: "ਅਕਾਲ ਕਿਡਜ਼ ਦੁਨੀਆ ਭਰ ਦੇ ਵਿਦਿਆਰਥੀਆਂ ਨੂੰ ਸੇਵਾ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ:",
    countries: [
      "ਭਾਰਤ",
      "ਅਮਰੀਕਾ",
      "ਕੈਨੇਡਾ",
      "ਯੂਨਾਈਟਿਡ ਕਿੰਗਡਮ",
      "ਆਸਟ੍ਰੇਲੀਆ",
      "ਹੋਰ ਦੇਸ਼",
    ],
    globalNote: "ਆਨਲਾਈਨ ਕਲਾਸਾਂ ਰਾਹੀਂ ਬੱਚੇ ਘਰ ਬੈਠੇ ਗੁਰਮਤਿ ਸਿੱਖ ਸਕਦੇ ਹਨ।",
    supportTitle: "ਸੰਪਰਕ ਸਮਾਂ",
    supportHours: "ਸਹਾਇਤਾ ਸਮਾਂ",
    supportTime:
      "ਸੋਮਵਾਰ ਤੋਂ ਸ਼ਨੀਵਾਰ\nਸਵੇਰੇ 10:00 ਵਜੇ ਤੋਂ ਸ਼ਾਮ 7:00 ਵਜੇ ਤੱਕ( IST)",
    supportNote: "ਸਮਾਂ ਤੋਂ ਬਾਹਰ ਆਏ ਸੁਨੇਹਿਆਂ ਦਾ ਜਵਾਬ ਜਲਦੀ ਦਿੱਤਾ ਜਾਵੇਗਾ।",
    guidanceTitle: "ਕਿਸ ਲਈ ਸੰਪਰਕ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ?",
    guidanceDesc: "ਤੁਸੀਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰ ਸਕਦੇ ਹੋ:",
    guidancePoints: [
      "ਦਾਖਲੇ ਲਈ",
      "ਬੈਚ ਅਤੇ ਲੈਵਲ ਜਾਣਕਾਰੀ",
      "ਕਲਾਸ ਸਮਾਂ",
      "ਤਕਨੀਕੀ ਮਦਦ",
      "ਆਮ ਜਾਣਕਾਰੀ ਲਈ",
    ],
    guidanceNote: "ਸਾਡੀ ਟੀਮ ਧਿਆਨ, ਸਪਸ਼ਟਤਾ ਅਤੇ ਸਤਿਕਾਰ ਨਾਲ ਜਵਾਬ ਦੇਵੇਗੀ।",
    parentTitle: "ਮਾਤਾ-ਪਿਤਾ ਲਈ ਸੁਨੇਹਾ",
    parentDesc:
      "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਅਸੀਂ ਮੰਨਦੇ ਹਾਂ ਕਿ ਗੁਰਮਤਿ ਸਿੱਖਿਆ ਮਾਤਾ-ਪਿਤਾ ਅਤੇ ਅਧਿਆਪਕਾਂ ਦੀ ਸਾਂਝੀ ਜਿੰਮੇਵਾਰੀ ਹੈ ।",
  },
};

export default contactTranslations;
